import {
    buildComponentSlice,
    useComponentSlice,
    WidgetComponentSliceActionPayloadType,
} from 'widgets/store/component/componentSlice';

import { WidgetType } from 'widgets/WidgetType';
import { FillsGraphComponentState } from 'widgets/fillsGraph/store/component/FillsGraphComponentState';
import { selectFillsGraphState } from 'widgets/fillsGraph/store/selectors';

export const buildFillsGraphComponentSlice = () =>
    buildComponentSlice<FillsGraphComponentState>(
        WidgetType.FILLS_GRAPH,
        selectFillsGraphState,
        {}
    );

export const useFillsGraphComponentSlice = () =>
    useComponentSlice(buildFillsGraphComponentSlice());

export type FillsGraphComponentPayloadType =
    WidgetComponentSliceActionPayloadType<FillsGraphComponentState>;
